<div class="data-loading">
    <div class="loader">
        <div class="loaderBar"></div>
    </div>
</div>